{
  "randevu_sonuc_tip": {
    "Baslik": "Randevu Sonuç Tipleri",
    "Ad": "Ad",
    "Kod": "Kod",
    "Hedef 1": "1 Görüşme Hedef",
    "Hedef 2": "2 Görüşme Hedef",
    "Dahil": "Dahil",
    "Dahil Degil": "Dahil Değil",
    "Durum": "Durum",
    "Arama": "Arama",
    "Ara": "Ara",
    "Temizle": "Temizle",
    "Kapat": "Kapat",
    "Yenile": "Yenile",
    "Data Yenile": "Verileri Güncelle",
    "Ekle": "Ekle",
    "Filtrele": "Filtrele",
    "Duzenle": "Düzenle",
    "Sil": "Sil",
    "Kaydet": "Kaydet",
    "Guncelle": "Güncelle",
    "Vazgec": "Vazgeç",
    "Hepsi": "Hepsi",
    "Aktif": "Aktif",
    "Pasif": "Pasif",
    "ARA": "Ara"
  }
}
